export default 'm21.692 5.745-3.624-3.668L12 8.217l-6.068-6.14-3.624 3.668 6.067 6.14-6.067 6.14 3.624 3.667L12 15.552l6.067 6.14 3.625-3.668-6.067-6.14 6.067-6.14Z';
